import React, { FC } from 'react';
import { setClass } from '@utils';

interface IShowMoreButtonProps {
  onClick: () => void;
  isWeekendHoliday?: boolean
}

export const ShowMoreButton: FC<IShowMoreButtonProps> = ({ onClick, isWeekendHoliday = false }) => (
  <div
    className={setClass('show-more', isWeekendHoliday && 'weekend-holiday')}
    onClick={onClick}
  >
    Еще...
  </div>
);
